import * as React from 'react';
import {WithStyles, withStyles,} from '@material-ui/core';
import TranslateNew from '@translate/TranslateNew';
import { VVTimePickerStyle } from './timepicker.style';
import { styleColors } from 'src/main.style';

const tn: TranslateNew = TranslateNew.getInstance();

interface IProps extends WithStyles<typeof VVTimePickerStyle> {
  open:boolean;
  date:Date;
  setDate:(date:Date) => void;
  minYear?: number;
  maxYear?: number;
}

class VVFullDatePicker extends React.Component<IProps> {

  private lastMonthScrollTime = 0;
  private monthsScrolledDown = -1;
  private touchStartY = 0;
  private touchStartTop = 0;

  private scrollYearRef: React.RefObject<HTMLDivElement> = React.createRef();
  private scrollYearRefValues: Array<React.RefObject<HTMLDivElement>> = [];

  private scrollMonthRef: React.RefObject<HTMLDivElement> = React.createRef();

  private scrollMonthRefValues: Array<React.RefObject<HTMLDivElement>> = [React.createRef(),React.createRef(),React.createRef(),
    React.createRef(),React.createRef(),React.createRef(),React.createRef(),React.createRef(),React.createRef(),React.createRef(),
    React.createRef(),React.createRef()];

  private scrollDayRef: React.RefObject<HTMLDivElement> = React.createRef();

  private scrollDayRefValues: Array<React.RefObject<HTMLDivElement>> = [
    React.createRef(),React.createRef(),React.createRef(),React.createRef(),React.createRef(),React.createRef(),
    React.createRef(),React.createRef(),React.createRef(),React.createRef(),React.createRef(),React.createRef(),
    React.createRef(),React.createRef(),React.createRef(),React.createRef(),React.createRef(),React.createRef(),
    React.createRef(),React.createRef(),React.createRef(),React.createRef(),React.createRef(),React.createRef(),
    React.createRef(),React.createRef(),React.createRef(),React.createRef(),React.createRef(),React.createRef(),
    React.createRef(),React.createRef(),React.createRef(),React.createRef(),React.createRef(),React.createRef(),
    React.createRef(),React.createRef(),React.createRef(),React.createRef(),React.createRef(),React.createRef(),
    React.createRef(),React.createRef(),React.createRef(),React.createRef(),React.createRef(),React.createRef(),
    React.createRef(),React.createRef(),React.createRef(),React.createRef(),React.createRef(),React.createRef(),
    React.createRef(),React.createRef(),React.createRef(),React.createRef(),React.createRef(),React.createRef(),
    React.createRef(),React.createRef(),React.createRef(),React.createRef(),React.createRef(),React.createRef(),
    React.createRef(),React.createRef(),React.createRef(),React.createRef(),React.createRef(),React.createRef(),
    React.createRef(),React.createRef(),React.createRef(),React.createRef(),React.createRef(),React.createRef(),];

  public componentDidMount() {
    this.reset(this.props.date);
  }

  public componentDidUpdate(prevProps:IProps) {
    if (this.props.open !== prevProps.open
      || this.props.minYear !== prevProps.minYear || this.props.maxYear !== prevProps.maxYear) {
      this.reset(this.props.date);
    }
  }

  public renderOptions(nomOption:number) {
    const elements:JSX.Element[] = [];
    for (let index = 0; index < nomOption; index++) {
      elements.push(<div className={this.props.classes.scrollOption} key={index}
        onClick={(e) => e.currentTarget.scrollIntoView({behavior:"smooth", block:"center"})}/>)
    }
    return elements;
  }

  public renderDays(nomOption:number) {
    const elements:JSX.Element[] = [];
    const daysInCurrentMonth = this.getDaysInMonth(this.props.date.getMonth(), this.props.date.getFullYear());
    for (let index = 0; index < nomOption; index++) {
      
      elements.push(<div className={this.props.classes.option+" "+this.props.classes.dateOption} 
        ref={this.scrollDayRefValues[index]}  key={index}>
          {((index)%daysInCurrentMonth)+1}
        </div>)
    }
    return elements;
  }

  public render() {
    const {classes, open} = this.props;

    return (
      <div className={classes.timePicker} style={{maxHeight:(open?170:0),minHeight:(open?170:0)}}>
      <div className={classes.timepickerViewport} style={{maxWidth:'170px'}}>

        <div className={classes.scrollPane} style={{left:0, width :70}} onScroll={this.handleScrollYear} ref={this.scrollYearRef}
          // onTouchStartCapture={(e) => this.onTouchStart(e, this.scrollYearRef.current)} // fallback pan
          // onTouchMoveCapture={(e) => this.onTouchMove(e, this.scrollYearRef.current)}   // fallback pan
        >
          {this.renderOptions(this.getLastYear() - this.getFirstYear() + 5)}
        </div>
        <div className={classes.scrollPane} style={{left:70, width:50}} onScroll={this.handleScrollMonth} ref={this.scrollMonthRef}
          // onTouchStartCapture={(e) => this.onTouchStart(e, this.scrollMonthRef.current)} // fallback pan
          // onTouchMoveCapture={(e) => this.onTouchMove(e, this.scrollMonthRef.current)}    // fallback pan
          >
          {this.renderOptions(72)}
        </div>
        <div className={classes.scrollPane} style={{left:120, width:50}} onScroll={() => this.handleScrollDay(this.props.date, true)}
          // onTouchStartCapture={(e) => this.onTouchStart(e, this.scrollDayRef.current)} // fallback pan
          // onTouchMoveCapture={(e) => this.onTouchMove(e, this.scrollDayRef.current)}    // fallback pan
          ref={this.scrollDayRef}> {this.renderOptions(78)} </div>
        <div className={classes.wheelMarker} style={{width:'134px'}} />
        <div className={classes.wheel} style={{width:'70px'}}>
          {this.renderYears()}
        </div>
        <div className={classes.wheel} style={{width:'50px'}}>
          <div className={classes.option+" "+this.props.classes.monthOption} ref={this.scrollMonthRefValues[0]} >
            {tn.lang.januaryShort}</div>
          <div className={classes.option+" "+this.props.classes.monthOption} ref={this.scrollMonthRefValues[1]} >
            {tn.lang.decemberShort}</div>
          <div className={classes.option+" "+this.props.classes.monthOption} ref={this.scrollMonthRefValues[2]} >
            {tn.lang.novemberShort}</div>
          <div className={classes.option+" "+this.props.classes.monthOption} ref={this.scrollMonthRefValues[3]} >
            {tn.lang.octoberShort}</div>
          <div className={classes.option+" "+this.props.classes.monthOption} ref={this.scrollMonthRefValues[4]} >
            {tn.lang.septemberShort}</div>
          <div className={classes.option+" "+this.props.classes.monthOption} ref={this.scrollMonthRefValues[5]} >
            {tn.lang.augustShort}</div>
          <div className={classes.option+" "+this.props.classes.monthOption} ref={this.scrollMonthRefValues[6]} >
            {tn.lang.julyShort}</div>
          <div className={classes.option+" "+this.props.classes.monthOption} ref={this.scrollMonthRefValues[7]} >
            {tn.lang.juneShort}</div>
          <div className={classes.option+" "+this.props.classes.monthOption} ref={this.scrollMonthRefValues[8]} >
            {tn.lang.mayShort}</div>
          <div className={classes.option+" "+this.props.classes.monthOption} ref={this.scrollMonthRefValues[9]} >
            {tn.lang.aprilShort}</div>
          <div className={classes.option+" "+this.props.classes.monthOption} ref={this.scrollMonthRefValues[10]} >
            {tn.lang.marchShort}</div>
          <div className={classes.option+" "+this.props.classes.monthOption} ref={this.scrollMonthRefValues[11]} >
            {tn.lang.februaryShort}</div>
        </div>
        <div className={classes.wheel} style={{width:'50px'}}>
          {this.renderDays(78)}
        </div>
      </div>
      </div>
    );
  }

  private getFirstYear = () => this.props.minYear === undefined ? new Date().getFullYear() - 1 : this.props.minYear;

  private getLastYear = () => this.props.maxYear === undefined ? new Date().getFullYear() + 5 : this.props.maxYear;

  private renderYears() {
    const elements: JSX.Element[] = [];
    const count = this.getLastYear() - this.getFirstYear() + 1;
    this.scrollYearRefValues.length = count;
    for (let index = 0; index < count; index++) {
      if (!this.scrollYearRefValues[index]) {this.scrollYearRefValues[index] = React.createRef();}
      elements.push(
        <div className={this.props.classes.option + " " + this.props.classes.yearOption}
          ref={this.scrollYearRefValues[index]} key={index}>
          {this.getFirstYear() + index}
        </div>
      );
    }
    return elements;
  }

  private reset = (date:Date) => {
    const daysInCurrentMonth = this.getDaysInMonth(this.props.date.getMonth(), this.props.date.getFullYear());
    if (this.scrollDayRef.current) {
      this.scrollDayRef.current.scrollTop = 34*(daysInCurrentMonth+date.getDate()-1);
    }
    this.handleScrollDay(this.props.date, true);
    if (this.scrollMonthRef.current) {
      this.scrollMonthRef.current.scrollTop = 34*(12+date.getMonth());
      this.monthsScrolledDown = 12+date.getMonth();
    }
    this.handleScrollMonth();
    if (this.scrollYearRef.current) {
      this.scrollYearRef.current.scrollTop = 34*(date.getFullYear() - this.getFirstYear());
    }
    this.handleScrollYear();
  }

  // Fallback pan handlers
  private onTouchStart = (e: React.TouchEvent<HTMLDivElement>, el:any) => {
    // const el = this.scrollDateRef.current;
    if (!el) return;
    this.touchStartY = e.touches[0].clientY;
    this.touchStartTop = el.scrollTop;
  };

  private onTouchMove = (e: React.TouchEvent<HTMLDivElement>, el:any) => {
    // const el = this.scrollDateRef.current;
    if (!el) return;

    const dy = e.touches[0].clientY - this.touchStartY;
    const prev = el.scrollTop;
    el.scrollTop = this.touchStartTop - dy;

    // If we actually scrolled the inner element, keep the gesture here.
    if (el.scrollTop !== prev) {
      e.stopPropagation();  // don’t let body/page handlers hijack it
      e.preventDefault();   // prevent page scroll while we pan the inner scroller
    }
  };

  private handleScrollYear = () =>  {

    const container = this.scrollYearRef.current;
    if (container) {
      const scrollDegrees = ((container.scrollTop*30) / 34);
      const stepsScrolledDown = Math.max(0, Math.min(this.getLastYear() - this.getFirstYear(),
        Math.round(container.scrollTop / 34)));
      const scrolledToYear = stepsScrolledDown + this.getFirstYear();
      
      if (scrolledToYear !== this.props.date.getFullYear()) {
        const newDAte = new Date(this.props.date);
        const day = Math.min(newDAte.getDate(), this.getDaysInMonth(newDAte.getMonth(), scrolledToYear));
        newDAte.setFullYear(scrolledToYear, newDAte.getMonth(), day);
        this.props.setDate(newDAte);
        this.lastMonthScrollTime = Date.now();
        if (this.scrollDayRef.current) {
          const daysInMonth = this.getDaysInMonth(newDAte.getMonth(), scrolledToYear);
          this.scrollDayRef.current.scrollTop = 34 * (daysInMonth + day - 1);
        }
        this.handleScrollDay(newDAte, false);
      }

      let i = 0;
      for (const ref of this.scrollYearRefValues) {
        if (ref.current) {

          const distance = Math.abs(i - stepsScrolledDown);

          if (distance <= 3) {
            ref.current.style.transform = `rotateX(${(30 * -i)+scrollDegrees}deg) translateZ(70px)`;
            ref.current.style.color = (distance === 0)?styleColors.black:'#bbbbbb';  
            ref.current.style.opacity = "1";
          } else {
            ref.current.style.opacity = "0";
          }
        }
        i++;
      }
    }
  }

  private handleScrollMonth = () =>  {
    
    const container = this.scrollMonthRef.current;
    if (container) {
      this.lastMonthScrollTime = Date.now();
      const scrollDegrees = mod(((container.scrollTop*30) / 34) , 360);
      const stepsScrolledDown = ((Math.round(container.scrollTop / 34)));

      const scrolledToMonth = mod(stepsScrolledDown , 12);
      let selectedIndex = 12- scrolledToMonth;
      if (selectedIndex === 12) {selectedIndex = 0;}


      if (scrolledToMonth !== this.props.date.getMonth()) {
        const delta = stepsScrolledDown - this.monthsScrolledDown;
        this.monthsScrolledDown = stepsScrolledDown;

        const newDAte = new Date(this.props.date);
        const daysInNextMonth = this.getDaysInMonth(newDAte.getMonth()+delta, newDAte.getFullYear());
        
        if (newDAte.getDate() > daysInNextMonth) {
          newDAte.setDate(daysInNextMonth)
        }
        newDAte.setMonth(scrolledToMonth)
        this.props.setDate(newDAte);
        
        if (this.scrollDayRef.current) {
          this.scrollDayRef.current.scrollTop = 34*(daysInNextMonth+newDAte.getDate()-1);
        }
        this.handleScrollDay(newDAte, false);
    
      }


      let i = 0;
      for (const ref of this.scrollMonthRefValues) {
        if (ref.current) {

          // Calculate the direct distance
          const directDistance = Math.abs(i - selectedIndex);
          //  Calculate the looped distance considering the range is 0-11 (so, a total of 12 positions)
          const loopedDistance = (12 - directDistance);
          // Determine the smallest distance
          const distance = Math.min(directDistance, loopedDistance);

          if (distance <= 3) {
            ref.current.style.transform = `rotateX(${(30 * i)+scrollDegrees}deg) translateZ(70px)`;
            ref.current.style.color = (selectedIndex === i)?styleColors.black:'#bbbbbb';  
            ref.current.style.opacity = "1";
          } else {
            ref.current.style.opacity = "0";
          }
        }
        i++;
      }
    }
  }


  private handleScrollDay = (date:Date, sendUpdate:boolean) =>  {

    if ((Date.now() - this.lastMonthScrollTime ) < 300 && sendUpdate === true) {
      return;
    }
    const container = this.scrollDayRef.current;
    if (container) {
      const scrollDegrees = ((container.scrollTop*30) / 34);
      const stepsScrolledDown = (Math.round(container.scrollTop / 34));

      const daysInCurrentMonth = this.getDaysInMonth(date.getMonth(), date.getFullYear());
      const scrolledToDay = mod((stepsScrolledDown),daysInCurrentMonth)+1
      
      // console.log(scrolledToDay)

      if (scrolledToDay !== date.getDate() && sendUpdate) {
        const newDAte = new Date(date);
        newDAte.setDate(scrolledToDay)
        this.props.setDate(newDAte);
      }

      let i = 0;
      for (const ref of this.scrollDayRefValues) {
        if (ref.current) {

          const distance = Math.abs(i - stepsScrolledDown);

          if (distance <= 3) {
            ref.current.style.transform = `rotateX(${(30 * -i)+scrollDegrees}deg) translateZ(70px)`;
            ref.current.style.color = (distance === 0)?styleColors.black:'#bbbbbb';  
            ref.current.style.opacity = "1";
          } else {
            ref.current.style.opacity = "0";
          }
        }
        i++;
      }
    }
  }

  private getDaysInMonth = (month: number, year: number): number => {
    return new Date(year, month + 1, 0).getDate();
  };

}

const mod = (n: number, m: number) => ((n % m) + m) % m;

export default withStyles(VVTimePickerStyle)(VVFullDatePicker);



// WEBPACK FOOTER //
// ./src/components/common/timepicker/VVFullDatePicker.tsx